<template>
  <div>
    <l-bg />
    <l-stripes :count="0">
      <curveElement
        :withAuto="false"
      />
    </l-stripes>
    <l-popupMessage
      :items="messages"
      @click="() => $emit('nextStep', 2)"
    />
  </div>
</template>
<script>
import { ref, onMounted } from '@vue/composition-api'

import curveElement from '@/views/Education1/Lesson1/components/curve'

import { pushPopup } from '@/utils/pushPopup'

const arr = [
  { text: 'Звук — это волна. Но как непрерывный сигнал записать в компьютер так, чтобы потом его можно было восстановить?' },
  { text: 'Дана волна - аналоговый звуковой сигнал. Давай покажем Роботу, как ее оцифровать.', buttonTitle: 'Продолжить' },
]

export default {
  name: 'step1',
  components: {
    curveElement,
  },
  setup() {
    const messages = ref([])

    onMounted(() => {
      pushPopup(arr, messages.value)
    })

    return {
      messages,
    }
  },
}
</script>
